import { render, staticRenderFns } from "./WebchatPreferences.vue?vue&type=template&id=2a98d007&scoped=true&"
import script from "./WebchatPreferences.vue?vue&type=script&lang=js&"
export * from "./WebchatPreferences.vue?vue&type=script&lang=js&"
import style0 from "./WebchatPreferences.vue?vue&type=style&index=0&id=2a98d007&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a98d007",
  null
  
)

export default component.exports